import React, { type FC } from "react";
import GoBackHeaderContent from "@components/AuthFlow/Header/GoBackHeaderContent";
import { screenNames } from "clientState/AuthFlow/providers/ScreenProvider";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Body, Box, Flex, Heading } from "@edreamsodigeo/prisma-design-system";

import type { HeaderProps } from "../MyTripsLogin/contract";

const IncentivizeMyTripsLoginHeader: FC<HeaderProps> = ({
  mytripsLoginFlow,
  onRenderPasswordless,
}) => {
  const { t } = useTranslation();
  const { SIGNIN } = screenNames;

  return (
    <Flex flexDirection="column" gap="1x_small" pb="base">
      {mytripsLoginFlow === SIGNIN && (
        <Box ml="small" onClick={onRenderPasswordless} cursor="pointer">
          <GoBackHeaderContent screen={SIGNIN} />
        </Box>
      )}
      <Heading type="3" weight="medium" textAlign="start" color="neutral.90">
        {t("mytripslogin.managebookings.login.title")}
      </Heading>

      <Flex justifyContent="start" alignItems="start" gap="2x_small">
        <Body color="neutral.90" type="base" textAlign="start">
          {t("mytripslogin.managebookings.loginwithpassword.description")}
        </Body>
      </Flex>
    </Flex>
  );
};

export default IncentivizeMyTripsLoginHeader;
